import type { SendViewItemListConfig } from './types'
import { GtmItemListId } from './types'
import { parseKftEventToGtmItemListItem } from './parsers/parseKftEventToGtmItemListItem'

export const sendViewItemListConfig: SendViewItemListConfig = {
  [GtmItemListId.GeneralPageRecommendedEvents]: {
    listName: 'General Page Recommended Events',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.GeneralPageTopEvents]: {
    listName: 'General Page Top Events',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.GeneralPageGiftcardEvents]: {
    listName: 'General Giftcard Classes',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.GeneralPageTopGiftIdeas]: {
    listName: 'General Page Top Gift Ideas',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.GeneralPageNewEvents]: {
    listName: 'General Page New Events',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.GeneralPageLastViewedEvents]: {
    listName: 'General Page Last Viewed Events',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.GeneralPageKits]: {
    listName: 'General Page Kits',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.KitsPageKits]: {
    listName: 'Kits Page Kits',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.EventPageSimilarClasses]: {
    listName: 'Event Page Similar Classes',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.EventPageSimilarClassesTop]: {
    listName: 'Event Page Similar Classes on Top',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.EventPageSameSupplierClasses]: {
    listName: 'Event Page Same Supplier Classes',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.EventPageSimilarOnlineClasses]: {
    listName: 'Event Page Similar Online Classes',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.GiftcardPageGiftcardEvents]: {
    listName: 'Giftcard Page Giftcard Classes',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.MagazineArticlePageSupplierClasses]: {
    listName: 'Magazine Article Page Supplier Classes',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.MagazineArticlePageVideoClasses]: {
    listName: 'Magazine Article Page Video Classes',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.TeameventPageTopEvents]: {
    listName: 'Teamevent Page Top Events',
    parser: parseKftEventToGtmItemListItem,
  },
  [GtmItemListId.ReviewSuccessPageRecommendedEvents]: {
    listName: 'Review Success Page Recommended Events',
    parser: parseKftEventToGtmItemListItem,
  },
  // Example of a different type of data below
  // [GtmItemListId.GeneralPageCategories]: {
  //   listName: "General Page Categories",
  //   parser: parseKftCategoryToGtmItemListItem,
  // },
}
